import { styled } from 'styled-components';

export const Container = styled.div`
    grid-column: auto / span 6;
`;
